import React, { useEffect, useState } from "react";
import axios from "axios";
import { APP_TYPE, COLLEGE } from "../../../../utils";
import { ServiceUrl } from "../../../../utils/serviceUrl";
import { Card } from "react-bootstrap";
import { Spin } from "antd";

const Style2 = () => {
  const [dataList, setDataList] = useState([]);
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = () => {
    setLoader(true);
    let url = "";
    if (APP_TYPE === "SAAS") url = "?sadb=" + COLLEGE;
    axios.get(ServiceUrl.ADMISSION.ANNOUNCEMENTS + url).then((res) => {
      if (res["data"].status == "1") {
        setDataList(res["data"].data);
      }
      setLoader(false);
    });
  };

  return (
    <div className="text-center text-md-start slide-up-animation pb-2 style-2-container">
      <div className="d-inline-flex align-items-center bg-white bg-opacity-10 border border-white border-opacity-25 rounded-pill px-3 py-1 mb-3 backdrop-blur shadow-sm sliding-pill">
        <span className="badge bg-warning text-dark rounded-pill me-2 only-new-sliding">
          NEWS
        </span>
        <span className="text-white fs-13 fw-600 letter-spacing-1 admission-text-fixed">
          Important Updates
        </span>
      </div>
      <h3 className="text-white fw-900 display-4 mb-2 text-shadow-sm">
        Latest Notifications
      </h3>
      <p className="text-light fs-16 fw-500 opacity-75 max-w-600 mx-auto mx-md-0 mb-4">
        Stay updated with the latest news, events, and important announcements
        regarding admission.
      </p>

      <Card className="border-0 bg-white bg-opacity-10 backdrop-blur text-white announcement-card-fixed-wrapper overflow-hidden">
        <Card.Body className="p-4">
          <Spin spinning={loader}>
            <div
              className="ps-v-marquee-container mt-2"
              style={{ height: "350px" }}
            >
              <div className="ps-v-marquee-content">
                {[...dataList, ...dataList].map((item, index) => (
                  <div key={index} className="announcement-list-item mb-4 pb-3">
                    <div className="d-flex align-items-center mb-2">
                      <div className="bg-warning text-dark px-2 py-1 rounded me-2 fs-10 fw-900 border-radius-5">
                        NEW
                      </div>
                      <div
                        className="fs-18 fw-700 text-white letter-spacing-05"
                        dangerouslySetInnerHTML={{ __html: item.title }}
                      />
                    </div>
                    <div
                      className="fs-14 opacity-85 text-light announcement-html-content lh-base"
                      dangerouslySetInnerHTML={{ __html: item.content_html }}
                    />
                  </div>
                ))}
              </div>
            </div>
          </Spin>
        </Card.Body>
      </Card>
    </div>
  );
};

export default Style2;
